import { useEffect } from 'react'

export function useTailwindHeight() {
  useEffect(() => {
    function setDocHeight() {
      document.documentElement.style.setProperty('--vh', `${window.innerHeight / 100}px`)
    }

    window.addEventListener('resize', setDocHeight)
    window.addEventListener('orientationchange', setDocHeight)

    setDocHeight()

    return () => {
      window.removeEventListener('resize', setDocHeight)
      window.removeEventListener('orientationchange', setDocHeight)
    }
  }, [])
}
